import { Factory, trait } from 'miragejs';

export default Factory.extend({
  entityType: 'location',

  withMapFloorsAndFeatures: trait({
    afterCreate(areaMap, server) {
      server.createList('map-floor', 3, 'withFeatures', { areaMap });
    },
  }),

  withMapFloors: trait({
    afterCreate(areaMap, server) {
      server.create('map-floor', {
        areaMap,
        rasterImageUrl:
          'https://user-images.githubusercontent.com/1156865/192322191-d3fb1544-6529-463e-84fc-027aedf8f08a.png',
      });

      server.createList('map-floor', 2, { areaMap });
    },
  }),

  asDraft: trait({
    afterCreate(areaMap, server) {
      server.create('draft', { createdBy: 1, draftAreaMap: areaMap });
    },
  }),
});
